import { axiosInstance } from '@/components/axiosInstance'
import {
  setPreferHeader,
  type Headers,
} from '@/components/setAxiosPreferHeader'

/**
 *
 * @param postcode
 *
 * If API testing you can set prefer headers by including
 * a headers object, e.g.
    const response = await axiosInstance.post(url, {
      headers: {
        Prefer: 'statusCode=400,example=ValidationFailure',
      },
      validateStatus: function (status) {
        return status < 500
      },
    })
 */
const addressLookup = async (postcode: string): Promise<string[]> => {
  const headers: Headers = {
    ...setPreferHeader(window.location.search),
  }

  try {
    const postcodeApiUrl = import.meta.env.VITE_IDEAL_POSTCODES_URL
    const trimmedPostcode = postcode.replace(/ /g, '')
    const url = `${postcodeApiUrl}/postcodes/${trimmedPostcode}?api_key=${
      import.meta.env.VITE_IDEAL_POSTCODES_API_KEY
    }`
    const response = await axiosInstance.get(url, {
      headers,
      validateStatus: (status) => {
        return (status >= 200 && status < 300) || status === 404
      },
    })
    switch (response.status) {
      case 404: // Not found
        return []
      default: // Addresses found
        return response.data.result
    }
  } catch (error) {
    console.error(error)
    return []
  }
}

export default addressLookup
